/* global fetch */

import { ACTIVITY_HANDLER_URL } from '../activity-handler/activity-handler.constants';
import { buildActivityRequestHeaders } from '../activity-handler/activity-request-headers.util';
import type { AddinOrganisation } from './addin-organisation.model';
import { parseManagedOrganisations } from './parse-managed-organisations.util';

const GET_MANAGED_ORGANISATIONS_PAYLOAD = {
    activity: 'Get-ManagedOrganisations' as const,
    data: {} as Record<string, never>,
    originalActivity: null,
    isAsync: false,
    externalId: null,
};

export type FetchManagedOrganisationsResult =
    | { kind: 'success'; organisations: AddinOrganisation[] }
    | { kind: 'failure'; message: string };

/**
 * Organisations the authenticated user may operate in.
 * Omits `x-organization-code` so a previously selected child org does not narrow the list.
 */
export async function fetchGetManagedOrganisations(
    accessToken: string,
    activityHandlerUrl: string = ACTIVITY_HANDLER_URL
): Promise<FetchManagedOrganisationsResult> {
    try {
        const response = await fetch(activityHandlerUrl, {
            method: 'POST',
            headers: buildActivityRequestHeaders(accessToken, { includeOrganisationCode: false }),
            body: JSON.stringify(GET_MANAGED_ORGANISATIONS_PAYLOAD),
        });
        const body: unknown = await response.json().catch(() => null);
        const data =
            body !== null && typeof body === 'object' && 'data' in body
                ? (body as { data?: unknown }).data
                : undefined;
        if (!response.ok || data === undefined) {
            const message =
                body !== null &&
                typeof body === 'object' &&
                'message' in body &&
                typeof (body as { message: unknown }).message === 'string'
                    ? (body as { message: string }).message
                    : `Request failed with status ${response.status}`;
            return { kind: 'failure', message };
        }
        return { kind: 'success', organisations: parseManagedOrganisations(data) };
    } catch (error) {
        return {
            kind: 'failure',
            message: error instanceof Error ? error.message : String(error),
        };
    }
}
